/**
 * 枚舉
 * 表單 - 表格
 * @author J
 * @since 2024-05-19 22:27:25
 */

/**
 * 欄位
 */
export const FormTableFieldEnum = Object.freeze({

    /**
     * ID
     */
    ID: 0,

    /**
     * ID - 長
     */
    ID_MIDDLE: 1,

    /**
     * 所屬教會
     */
    BELONG: 2,

    /**
     * 總教會發起的推播
     */
    NOTIFICATION_HEAD: 3,

    /**
     * 單號
     */
    NO: 4,

    /**
     * 分類
     */
    CATEGORY: 5,

    /**
     * 頭像
     * 單傳入url
     */
    AVATAR: 6,

    /**
     * 用戶格式
     * Basic.User
     */
    USER: 7,

    /**
     * 統計
     */
    STATISTICS: 8,

    /**
     * 進度
     */
    PROGRESS: 9,

    /**
     * 建立時間
     */
    DATETIME: 10,

    /**
     * 提醒
     */
    REMIND: 11,

    /**
     * 循環
     */
    CYCLE: 12,

    /**
     * 建立時間
     */
    STATUS: 13,

    /**
     * 檢視
     */
    VIEW: 14,

    /**
     * 編輯
     */
    EDIT: 15,

})

/**
 * 排序
 */
export const FormTableSortEnum = Object.freeze({

    /**
     * 不排序
     */
    NONE: 0,

    /**
     * 升冪
     */
    ASC: 1,

    /**
     * 降冪
     */
    DESC: 2,

})

/**
 * 排序
 */
export const FormTableMoreEnum = Object.freeze({

    /**
     * 複製
     */
    COPY: 0,

    /**
     * 啟用
     */
    ENABLE: 1,

    /**
     * 停用
     */
    DISABLE: 2,

    /**
     * 刪除
     */
    DESTROY: 3,

    /**
     * 插槽
     */
    SLOT: 4,

})

/**
 * 搜尋
 */
export const FormTableSearchEnum = Object.freeze({

    /**
     * 輸入框
     */
    INPUT: 0,

    /**
     * 下拉選項
     */
    SELECT: 1,

    /**
     * 日期
     */
    DATE: 2,

    /**
     * 起/迄
     */
    DURING: 3,

    /**
     * 關鍵字
     */
    KEYWORD: 4,

    /**
     * 會友 - 關鍵字
     */
    KEYWORD_CLIENT: 5,

    /**
     * 插槽
     */
    SLOT: 6,

})

/**
 * 搜尋 - 區間 - 主鍵
 */
export const FormTableSearchDuringKeyEnum = Object.freeze({

    /**
     * 開始時間
     */
    ON: "on",

    /**
     * 結束時間
     */
    OFF: "off",

    /**
     * 建立時間
     */
    SUBMIT: "submit",

})

/**
 * 搜尋 - 區間 - 次鍵
 */
export const FormTableSearchDuringSubKeyEnum = Object.freeze({

    /**
     * 起
     */
    BEGIN: "begin",

    /**
     * 迄
     */
    END: "end",

})

/**
 * 搜尋 - 區間 - 組合鍵
 */
export const FormTableSearchDuringCombineKeyEnum = Object.freeze({

    /**
     * 開始時間 - 起
     */
    ON_BEGIN: "on.begin",

    /**
     * 開始時間 - 迄
     */
    ON_END: "on.end",

    /**
     * 結束時間 - 起
     */
    OFF_BEGIN: "off.begin",

    /**
     * 結束時間 - 迄
     */
    OFF_END: "off.end",

    /**
     * 建立時間 - 起
     */
    SUBMIT_BEGIN: "submit.begin",

    /**
     * 建立時間 - 迄
     */
    SUBMIT_END: "submit.end",

})